import { v4 as uuidv4 } from "uuid";
import { getLocalStorageString, setLocalStorageString } from "./localstorage";
var AlmadLogLevel;
(function (AlmadLogLevel) {
    AlmadLogLevel[AlmadLogLevel["Info"] = 0] = "Info";
    AlmadLogLevel[AlmadLogLevel["Warn"] = 1] = "Warn";
    AlmadLogLevel[AlmadLogLevel["Error"] = 2] = "Error";
    AlmadLogLevel[AlmadLogLevel["Debug"] = 3] = "Debug";
})(AlmadLogLevel || (AlmadLogLevel = {}));
function severityToString(severity) {
    switch (severity) {
        case AlmadLogLevel.Info:
            return "INFO";
        case AlmadLogLevel.Warn:
            return "WARN";
        case AlmadLogLevel.Error:
            return "ERROR";
        case AlmadLogLevel.Debug:
            return "DEBUG";
        default:
            return "UNKNOWN";
    }
}
const getTimestamp = () => {
    const today = new Date();
    const timestamp = `${today
        .getHours()
        .toString()
        .padStart(2, "0")}:${today
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${today
        .getSeconds()
        .toString()
        .padStart(2, "0")}:${today.getMilliseconds().toString().padStart(3, "0")}`;
    return timestamp;
};
const didHaveDebugParam = window?.location?.search?.indexOf("almad_debug=true") !== -1;
const logMessage = (namespace, severity, ...args) => {
    const loggingEnabled = didHaveDebugParam ||
        getLocalStorageString("almad_debug") === "true" ||
        Number.parseInt(getLocalStorageString("almad_loglevel") ?? "-1", 10) >=
            severity;
    if (loggingEnabled && "console" in window) {
        // eslint-disable-next-line no-console
        console.log(`[${getTimestamp()}] adtech-stack | ${namespace} | ${severityToString(severity)}: ${args}`);
    }
};
function logEventStart(namespace, event, payload = "") {
    if (getLocalStorageString("almad_perf") === "true") {
        const msgBody = `[${getTimestamp()}] adtech-stack | perf | ${namespace}: ${event}-start`;
        const message = payload ? `${msgBody} - ${payload}` : msgBody;
        // eslint-disable-next-line no-console
        console.time(event);
        // eslint-disable-next-line no-console
        console.log(message);
    }
}
function logEventEnd(namespace, event, payload = "") {
    if (getLocalStorageString("almad_perf") === "true") {
        const msgBody = `[${getTimestamp()}] adtech-stack | perf | ${namespace}: ${event}-end`;
        const message = payload ? `${msgBody} - ${payload}` : msgBody;
        // eslint-disable-next-line no-console
        console.timeEnd(event);
        // eslint-disable-next-line no-console
        console.log(message);
    }
}
function createLogger(namespace) {
    const events = new Map();
    const logPerformance = getLocalStorageString("almad_perf") === "true";
    // We need to check if these exist
    const supportsPerf = typeof window?.console?.time !== "undefined" &&
        typeof window?.console?.timeEnd !== "undefined" &&
        typeof window?.performance?.now !== "undefined";
    return {
        logInfo: (...args) => logMessage(namespace, AlmadLogLevel.Info, args),
        logWarn: (...args) => logMessage(namespace, AlmadLogLevel.Warn, args),
        logError: (...args) => logMessage(namespace, AlmadLogLevel.Error, args),
        logDebug: (...args) => logMessage(namespace, AlmadLogLevel.Debug, args),
        perfEventStart: (event, payload) => {
            if (supportsPerf) {
                if (logPerformance) {
                    events.set(uuidv4(), {
                        name: event,
                        timestamp: window.performance.now(),
                        payload,
                    });
                }
                logEventStart(namespace, event, payload);
            }
        },
        perfEventEnd: (event, payload) => {
            if (supportsPerf) {
                if (logPerformance) {
                    events.set(uuidv4(), {
                        name: event,
                        timestamp: window.performance.now(),
                        payload,
                    });
                }
                logEventEnd(namespace, event, payload);
                try {
                    setLocalStorageString("almad_perf_results", JSON.stringify(Array.from(events)));
                }
                catch (e) {
                    console.warn("Perf failed");
                }
            }
        },
    };
}
export { createLogger };
//# sourceMappingURL=logger.js.map